(() => {
  const records = new WeakMap();
  const update = (scope, id) => {
    scope.querySelectorAll('[data-ks-delivery-row]').forEach(row => {
      let data = records.get(row);
      if (!data) {
        data = JSON.parse(row.querySelector('[data-ks-delivery-data]').textContent);
        records.set(row, data);
      }
      const variant = data.variants.find(item => String(item.id) === String(id === undefined ? data.selected : id));
      const available = Boolean(variant?.available);
      const backorder = Boolean(variant?.backorder);
      row.dataset.available = String(available);
      row.dataset.backorder = String(backorder);
      row.querySelector('[data-ks-stock-text]').textContent = available ? (backorder ? data.backorder : data.inStock) : data.soldOut;
      row.querySelector('[data-ks-delivery]').hidden = !available || backorder;
    });
  };
  const initialize = scope => {
    update(scope);
    scope.querySelectorAll('[data-section-type="product"]').forEach(section => {
      if (section.dataset.deliveryReady || !window.jQuery) return;
      section.dataset.deliveryReady = 'true';
      window.jQuery(section).on('variantChange.ksDelivery', event => update(section, event.variant?.id || null));
    });
  };
  window.KensuiStockDelivery = { update };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
